'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

export const Contact: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="info-page">
            <Helmet>
                <title>{t('seo.contact.title')}</title>
                <meta name="description" content={t('seo.contact.description')} />
            </Helmet>
            <div className="container">
                <div className="info-card">
                    <h1>{t('seo.contact.title')}</h1>
                    <p>{t('seo.contact.description')}</p>
                </div>
            </div>
        </div>
    );
};
